import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import API_BASE_URL from '../../Config';


export default function TurnoCajaAdmin() {
  const [montoApertura, setMontoApertura] = useState('');
  const [montoCierre, setMontoCierre] = useState('');
  const [turnos, setTurnos] = useState([]);
  const [turnoActivo, setTurnoActivo] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/turnos-caja` )
      .then(res => {
        setTurnos(res.data);
        const abierto = res.data.find(t => !t.cerrado);
        setTurnoActivo(abierto || null);
      })
      .catch(err => console.error(err));
  }, []);

  const abrirTurno = async () => {
    const res = await axios.post(`${API_BASE_URL}/api/turnos-caja/abrir`, {
      montoApertura: Number(montoApertura)
    });
    setTurnoActivo(res.data);
    alert('🔓 Turno abierto');
    setMontoApertura('');
  };

  const cerrarTurno = async () => {
    if (!turnoActivo) return;
    await axios.put(`${API_BASE_URL}/api/turnos-caja/cerrar/${turnoActivo.id}?montoCierre=${montoCierre}`);
    alert('🔒 Turno cerrado');
    setTurnoActivo(null);
    setMontoCierre('');
    const actualizados = await axios.get(`${API_BASE_URL}/api/turnos-caja`);
    setTurnos(actualizados.data);
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Turno de Caja</h2>

      {!turnoActivo ? (
        <>
          <input
            type="number"
            placeholder="Monto de apertura"
            value={montoApertura}
            onChange={(e) => setMontoApertura(e.target.value)}
            className="border p-2 rounded w-full max-w-xs mb-4"
          />
          <Button onClick={abrirTurno}>🔓 Abrir turno</Button>
        </>
      ) : (
        <>
          <p className="mb-2 text-green-700">Turno activo desde: {new Date(turnoActivo.apertura).toLocaleString()}</p>
          <input
            type="number"
            placeholder="Monto de cierre"
            value={montoCierre}
            onChange={(e) => setMontoCierre(e.target.value)}
            className="border p-2 rounded w-full max-w-xs mb-4"
          />
          <Button onClick={cerrarTurno}>🔒 Cerrar turno</Button>
        </>
      )}

      <h3 className="text-xl font-semibold mt-6 mb-2">Historial de turnos</h3>
      <table className="w-full table-auto border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">ID</th>
            <th className="border p-2">Apertura</th>
            <th className="border p-2">Cierre</th>
            <th className="border p-2">Apertura (Gs)</th>
            <th className="border p-2">Cierre (Gs)</th>
            <th className="border p-2">Estado</th>
          </tr>
        </thead>
        <tbody>
          {turnos.map(turno => (
            <tr key={turno.id}>
              <td className="border p-2">{turno.id}</td>
              <td className="border p-2">{new Date(turno.apertura).toLocaleString()}</td>
              <td className="border p-2">{turno.cierre ? new Date(turno.cierre).toLocaleString() : '-'}</td>
              <td className="border p-2">{turno.montoApertura}</td>
              <td className="border p-2">{turno.montoCierre ?? '-'}</td>
              <td className="border p-2">{turno.cerrado ? '✅ Cerrado' : '🟢 Abierto'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
